import landing_piriji from '../images/projects/piriji/home_page.png'
import initial_screen_piriji from '../images/projects/piriji/initial_screen.png'
import results_piriji from '../images/projects/piriji/results.png'


import landing_popshop from '../images/projects/popshop/home_page.png'
import search_popshop from '../images/projects/popshop/search.png'
import results_popshop from '../images/projects/popshop/results.png'


import landing_team_randomizer from '../images/projects/team_randomizer/home_page.png'
import selecting_members_team_randomizer from '../images/projects/team_randomizer/selecting_member.png'
import results_team_randomizer from '../images/projects/team_randomizer/results.png'
import saved_results_team_randomizer from '../images/projects/team_randomizer/saved_results.png'


const piriji = [landing_piriji, initial_screen_piriji, results_piriji]
const popshop = [landing_popshop, search_popshop, results_popshop]
const team_randomizer = [landing_team_randomizer, selecting_members_team_randomizer, results_team_randomizer, saved_results_team_randomizer]

const data = {
    piriji,
    popshop,
    team_randomizer
}

export default data